<fuse-loading-bar></fuse-loading-bar>

<div class="flex flex-col flex-auto w-full">
    <div class="flex flex-col flex-auto">
        <router-outlet></router-outlet>
    </div>
</div>
